'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjsr_AnonFunction0() {
}
export { $c_sjsr_AnonFunction0 as $c_sjsr_AnonFunction0 };
$p = $c_sjsr_AnonFunction0.prototype = new $j_java$002elang$002e$002dObject.$h_sr_AbstractFunction0();
$p.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
}
export { $h_sjsr_AnonFunction0 as $h_sjsr_AnonFunction0 };
$h_sjsr_AnonFunction0.prototype = $p;
